import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { url: String }

  toggle() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden")
      if (!this.panelTarget.classList.contains("hidden")) {
        this.#load()
      }
    }
  }

  restore({ params: { query, queryType } }) {
    const textarea = document.querySelector("textarea[name='query']")
    if (textarea) {
      textarea.value = query
      textarea.dispatchEvent(new Event("input", { bubbles: true }))
    }

    if (queryType && queryType !== "esql") {
      const btn = document.querySelector(`[data-search-type="${queryType}"]`)
      btn?.click()
    }

    this.panelTarget?.classList.add("hidden")
  }

  #load() {
    const frame = document.querySelector("turbo-frame#siem-query-history")
    if (frame && !frame.src) {
      frame.src = this.urlValue
    }
  }
}
